import { GithubAuthProvider } from 'firebase/auth'

import { signInWithOauth2 } from './sign_in_with_oauth2'

/**
 * Starts a sign in/up flows using GitHub. Emits an error if any
 */
export const signInWithGithub = async () => {
	signInWithOauth2(new GithubAuthProvider())
}
